export const removeCmOrInFromSoilProbeDepths = (str: string) =>
  Number(str.split('cm').join('').split('in').join(''))
